module.exports = __webpack_public_path__ + "static/media/sent.1b6eb641.svg";